"use strict";
let {performance = {now: () => new Date().getTime()}} = window;

class Timer {
    constructor(rounding = 0) {
        this.startTime = undefined;
        this.stopTime = undefined;
        this.splits = [];
        this.rounding = rounding;
    }

    static start() {
        let timer = new this();
        timer.start();
        return timer;
    }

    isRunning() {
        return !!this.startTime && !this.stopTime;
    }

    start() {
        if(this.stopTime) {
            console.info('Starting timer after a previous stop. Resetting stop time');
            this.stopTime = undefined;
        }
        this.startTime = performance.now();
        return +this.startTime.toFixed(this.rounding);
    }

    stop() {
        if(this.startTime === 'undefined') {
            console.warn('Must call Timer.start() before Timer.stop()');
            return;
        }
        this.stopTime = performance.now();
        return +this.stopTime.toFixed(this.rounding);
    }

    split(label) {
        label = label ? `${label} - ` : '';
        this.splits.push(`${label}${this.runningTime()}`);
    }

    getSplits() {
        return this.splits.slice();
    }

    executionTime() {
        if(typeof(this.startTime) === 'undefined') {
            return 0;
        }
        if(typeof(this.stopTime) === 'undefined') {
            return this.runningTime();
        }
        return +(this.stopTime - this.startTime).toFixed(this.rounding);
    }

    runningTime() {
        if(typeof(this.startTime) === 'undefined') {
            return 0;
        }
        return +(performance.now() - this.startTime).toFixed(this.rounding);
    }
}

module.exports = {Timer};